import { connect } from 'react-redux';
import { resetFilter } from '../../../../../redux/product-listing/product-listing.actions';
import BackLink from './back-link';
const mapDispatchToProps = dispatch => ({
  resetFilter: () => dispatch(resetFilter({
    redirectAllSwag: true
  }))
});
export default connect(null, mapDispatchToProps)(BackLink);